import { render } from "./Fourth.vue?vue&type=template&id=e19620fa&scoped=true"
import script from "./Fourth.vue?vue&type=script&lang=js"
export * from "./Fourth.vue?vue&type=script&lang=js"

import "./Fourth.vue?vue&type=style&index=0&id=e19620fa&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\dragoncrew\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19620fa"]])

export default __exports__